import React from "react";
import { Button, classnames, Icon, PlainButton } from "@culturehq/components";

import { getImage, Trans } from "app/utils";
import imagesSizes from "constants/imagesSizes";
import { getIcon } from "constants/tagsTypes";

import styles from "./story-slider.module.scss";
import StoryTagsLegend from "./StoryTagsLegend";

const TrendingStoryCard = ({
  story,
  onOpen,
  selectedImage,
  isProfile,
  onStoryClick,
  selectedStory,
  showPoints = true
}) => {
  const handleStoryClick = () => {
    if (onStoryClick && story.answers) {
      onStoryClick(story);
      return;
    }
    onOpen();
  };

  const getCardSelectedClass = () => {
    if (onStoryClick) {
      return selectedStory?.id === story.id ? "selectedCard" : "";
    }

    return "";
  };

  return (
    <PlainButton
      aria-labelledby={story.id}
      className={`${styles.card} ${getCardSelectedClass()}`}
      style={{ backgroundImage: `url(${getImage(imagesSizes.SMALL, selectedImage)})` }}
      onClick={handleStoryClick}
    >
      <div id={story.id} style={{ display: "none" }}>{story.question}</div>
      <div className="Trending-Stories__overlay">
        <p className="Story-Tags__container">
          {story.storyQuestionTags.map(({ id, entityType, entity }) => (
            <span className="Story-Tags__item" key={id}>
              <Icon icon={getIcon(entityType)} className="category-icon" />
              {entity?.name}
            </span>
          ))}
          {story.storyQuestionTags.length === 0 && (
            <span className="Story-Tags__item">
              <Icon icon="global" className="category-icon Everyone--Tag" />
              <Trans>Everyone</Trans>
            </span>
          )}
        </p>
        <span className={classnames(styles.label, "Trending-Stories__title")}>{story.question}</span>
        {isProfile && (
          <div className="chq-btn">
            {story.answers ? (
              <>
                <Trans>Join this trend</Trans>
                <span className="Story-Tags__points">+{story.points}</span>
              </>
            ) : (
              <>
                <Trans>Share your story</Trans>
                <span className="Story-Tags__points">+100</span>
              </>
            )}
          </div>
        )}
        {selectedStory && selectedStory?.id === story.id && (
          <Button className="Trending-Stories__Share-btn" onClick={() => onOpen(true)}><Trans>Share Story</Trans></Button>
        )}
        <StoryTagsLegend
          isProfile={isProfile}
          selectedStory={selectedStory}
          story={story}
          showPoints={showPoints}
        />
      </div>
      {selectedStory && selectedStory.id !== story.id && (
        <div className="Trending-Stories__overlay--unselected" />
      )}
    </PlainButton>
  );
};

export default TrendingStoryCard;
